/**
 * 创建枚举
 *
 * const SexEnum = createEnum(list)
 * console.log(SexEnum.MAN)  // {key: "MAN", value: 1, label: "男"}
 * console.log(SexEnum.WOMAN.value)  // 2
 * console.log(SexEnum.valueOf(2))   // {key: "WOMAN", value: 2, label: "女"}
 * console.log(SexEnum.getLabel(1))  // 男
 *
 * @param list
 * @returns {{getLabel(*): *, valueOf(*): *}|*}
 */
export default function createEnum(list) {

  const map = {}
  for (const item of list) {
    map[item.key] = item
  }

  const valueToLabelMap = {}
  const valueMap = {}
  for (const key of Object.keys(map)) {
    const item = map[key]
    valueToLabelMap[item.value] = item.label
    valueMap[item.value] = item
  }

  return {
    ...map,
    list() {
      return list
    },
    valueOf(value) {
      return valueMap[value]
    },
    getLabel(value) {
      return valueToLabelMap[value]
    }
  }
}
